import { Button } from "@/components/base/buttons/button";
import { cx } from "@/utils/cx";

export type DateGranularity = "day" | "week" | "month";

interface DateGranularitySelectorProps {
  value: DateGranularity;
  onChange: (value: DateGranularity) => void;
  className?: string;
}

export const DateGranularitySelector: React.FC<DateGranularitySelectorProps> = ({ value, onChange, className }) => {
  return (
    <div className={cx("flex items-center gap-1 bg-primary border border-secondary p-1 rounded-lg h-10", className)}>
      <Button
        color="tertiary"
        size="sm"
        className={cx(
          "px-3 py-2 text-sm font-semibold h-8",
          value === "day"
            ? "bg-brand-primary shadow-sm text-secondary"
            : "text-quaternary hover:text-secondary hover:bg-brand-primary",
        )}
        onClick={() => onChange("day")}
      >
        Day
      </Button>
      <Button
        color="tertiary"
        size="sm"
        className={cx(
          "px-3 py-2 text-sm font-semibold h-8",
          value === "week"
            ? "bg-brand-primary shadow-sm text-secondary"
            : "text-quaternary hover:text-secondary hover:bg-brand-primary",
        )}
        onClick={() => onChange("week")}
      >
        Week
      </Button>
      <Button
        color="tertiary"
        size="sm"
        className={cx(
          "px-3 py-2 text-sm font-semibold h-8",
          value === "month"
            ? "bg-brand-primary shadow-sm text-secondary"
            : "text-quaternary hover:text-secondary hover:bg-brand-primary",
        )}
        onClick={() => onChange("month")}
      >
        Month
      </Button>
    </div>
  );
};
